import { Button, Modal, Paper, Typography } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";

export default function SessionConflictModal({
  isWarningSnackbarOpen,
  timer,
  handleCloseWarningSnackbar,
  logOut,
  handleClickAllow,
  handleClickDeny
}) {
  const dispatch = useDispatch();
 
  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
      open={isWarningSnackbarOpen}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="session-warning"
    >
      <Paper
        variant="outlined"
        sx={{
          maxWidth: 500,
          borderRadius: "md",
          p: 3,
          boxShadow: "lg",
        }}
      >
        <Typography id="modal-desc" textColor="text.tertiary">
          <b style={{ fontSize: "20px", paddingRight: "5px" }}>Oops!</b> It
          looks like another browser is using the username/password associated
          with this access. If this is not you, then please click the 'Deny'
          button below to continue this session. If you do not click the button
          within one minute, you will automatically be logged out and we will
          issue a One Time Password to the other browser session for
          authentication.
        </Typography>

        <div className="allow-deny">
          <Button
            sx={{ marginTop: "20px" }}
            onClick={handleClickAllow}
            className="allow-btn me-2 text-white"
          >
            {" "}
            Allow
          </Button>
          <Button
            sx={{ marginTop: "20px" }}
            onClick={handleClickDeny}
            className="deny-btn text-white"
          >
            {" "}
            Deny
          </Button>
        </div>

        <div className="time-remaining">
          Time remaining:
          <span className="timer-secs"> {timer}s</span>
        </div>
      </Paper>
    </Modal>
  );
}
